import React, { useEffect, useState } from "react";
import { CheckCircleOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const ListStaff = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(true);
  const [errors, set_errors] = useState({});
  const [ship_id, set_ship_id] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    const FORM_DATA = new FormData();
    try {
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if ((res?.status == true) === true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          STAFF_LIST_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const STAFF_LIST_API = (func_id) => {
    set_page_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", func_id);
    try {
      post(ApiURL.list_register_staff, FORM_DATA).then((res) => {
        if ((res?.status == true) === true) {
          setFilteredData(res?.staff);
          set_page_loader(false);
        } else {
          ErrorToast("Error Message", res?.response?.data?.message);
        }
      });
    } catch (error) {
      ErrorToast("Error Message", error);
      console.error("Error fetching Staff list:", error);
    } finally {
      set_page_loader(false);
    }
  };

  const STAFF_LIST_DELETE_API = (staff_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("staff_id", staff_id);
    post(ApiURL.staff_soft_delete, FORM_DATA).then((res) => {
      if ((res?.status == true) === true) {
        SuccessToast("Success!!", "Staff Details Successfully deleted.");
        SHIP_LIST_API();
      } else {
        ErrorToast("Error", "sorry staff details not deleted");
        set_errors(res?.errors);
      }
    });
  };

  const COMPANY_STAFF_STATUS_API = (staff_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_staff_id", staff_id);
    post(ApiURL.ship_staff_status, FORM_DATA).then((res) => {
      if ((res?.status == true) === true) {
        SuccessToast("Success!!", "Staff Status Successfully updated.");
        SHIP_LIST_API();
      } else {
        ErrorToast("Error", "sorry staff details not deleted ");
        set_errors(res?.errors);
      }
    });
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "staff_id",
      align: "center",
      key: "staff_id",
      sorter: (a, b) => a.staff_id - b.staff_id,
    },
    {
      title: "Name",
      dataIndex: "first_name",
      align: "center",
      key: "first_name",
    },

    {
      title: "Designation",
      dataIndex: "staff_role",
      align: "center",
      key: "staff_role",
    },
    {
      title: "Email",
      dataIndex: "staff_email",
      align: "center",
      key: "staff_email",
    },
    {
      title: "Date of Birth",
      dataIndex: "date_of_birth",
      align: "center",
      key: "date_of_birth",
      render: (text, record) => formatDate(record?.date_of_birth),
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      align: "center",
      key: "nationality",
    },
    {
      title: "Status",
      dataIndex: "staff_status",
      align: "center",
      key: "staff_status",
      render: (text, record) => {
        if (record.staff_status) {
          return <span className="table-status-activate">Active</span>;
        } else {
          return <span className="table-status-deactivate">Inactive</span>;
        }
      },
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <>
            <Popconfirm
              title="Change Status"
              description={`Do you want to change the status of ${record.first_name}?`}
              onConfirm={() => COMPANY_STAFF_STATUS_API(record.staff_id)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Change Status">
                <Button
                  type="primary"
                  size="small"
                  style={{ marginRight: "15px" }}
                  icon={<CheckCircleOutlined />}
                />
              </Tooltip>
            </Popconfirm>

            <Tooltip title="Edit Staff">
              <Button
                type="primary"
                size="small"
                onClick={() =>
                  navigate(`/company-staff-update/${btoa(record.staff_id)}/${btoa(record.ship_id)}`)
                }
                style={{ marginRight: "15px" }}
                icon={<EditOutlined />}
              />
            </Tooltip>

            <Popconfirm
              title="Delete Staff"
              description={`Are you sure you want to delete the staff "${record.first_name}"?`}
              onConfirm={() => STAFF_LIST_DELETE_API(record.staff_id)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Delete Staff">
                <Button type="primary" size="small" icon={<DeleteOutlined />} />
              </Tooltip>
            </Popconfirm>
          </>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <div className="row">
          <div className="col-3">
            <label className="block-label">Select Ship</label>
            <Select
              placeholder="---- Select Ship ----"
              style={{ width: "100%" }}
              value={ship_id}
              onChange={(value) => {
                set_ship_id(value);
                STAFF_LIST_API(value);
              }}
            >
              {ship_table_list?.length > 0 && (
                <>
                  {ship_table_list.map((ship) => (
                    <>
                      {!ship.soft_delete && (
                        <>
                          <Select.Option key={ship.id} value={ship.id}>
                            {ship.vessel_name}
                          </Select.Option>
                        </>
                      )}
                    </>
                  ))}
                </>
              )}
            </Select>
            {errors?.ship_id && <span style={{ color: "red" }}>{errors?.ship_id}</span>}
          </div>
        </div>
        <div className="row" style={{ padding: "10px" }}>
          <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
            <div className="theme-content-title text-left">
              <h3>Ship Staff List</h3>
            </div>
          </div>
          <div className="col-3"></div>
          <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="d-flex align-items-center">
              <Button
                type="primary"
                className="save_btn"
                onClick={() => navigate("/company-staff-add")}
              >
                Add Staff
              </Button>
              <Button
                type="primary"
                className="save_btn"
                onClick={() => navigate("/view-audit-trail-staff")}
                style={{ marginLeft: "10px" }}
              >
                Audit Trail
              </Button>
            </div>
          </div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={page_loader}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default ListStaff;
